import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { CardTransitionProvider } from './context/CardTransitionContext';
import { ConsentProvider } from './context/ConsentContext';
import './i18n';
// Font self-hosted (GDPR: nessun IP verso Google senza consenso). Solo i pesi
// realmente usati nel sito (censiti su src/styles) — vedi CHANGELOG.
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource-variable/bricolage-grotesque';
import './styles/index.css';
import './styles/utilities.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ConsentProvider>
          <CardTransitionProvider>
            <App />
          </CardTransitionProvider>
        </ConsentProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
